
import { repository } from 'src/jtech/jtech-repository'

export const ServiceObservationRepository = {

  nmInterfaceServiceObservationPesquisar: 'serviceObservation.pesquisar',

  nmInterfaceServiceObservationGravar: 'serviceObservation.gravar',

  loadDatatable: async function () {
    return await repository.resolveDatatable(this.nmInterfaceServiceObservationPesquisar)
  },

  async loadDatatableModel (params) {
    return await repository.resolveDatatableModel(this.nmInterfaceServiceObservationPesquisar, { ...params })
  },

  async loadForm () {
    return await repository.resolve(this.nmInterfaceServiceObservationGravar)
  },

  async createServiceObservation (params) {
    return await repository.create(this.nmInterfaceServiceObservationGravar, params)
  }

}
